module.exports = __webpack_public_path__ + "img/cognitive_data_img01.3c1d8f81.jpg";